<ng-container *ngIf="active !== undefined ? active : (isAnyAction$ | async)">
  <!-- Modo Spinner: solo renderiza el spinner sin wrappers para usar en botones -->
  <ng-container *ngIf="loadingClassSignal() === 'spinner'">
    <div *ngIf="showSpinner" class="custom-spinner spinner-only"></div>
  </ng-container>

  <!-- Modos completos: Toast, Screen, Inline -->
  <ng-container *ngIf="loadingClassSignal() !== 'spinner'">
    <div class="loading-container" [ngClass]="'loading-' + loadingClassSignal()">
      <div class="loading-content" [ngClass]="'content-' + loadingClassSignal()">
        <div *ngIf="showSpinner" class="custom-spinner" [ngClass]="'spinner-' + loadingClassSignal()"></div>
        
        <span class="loading-text" *ngIf="showText">
          <ng-container *ngIf="text !== undefined; else globalText">{{ text }}</ng-container>
          <ng-template #globalText>
            <span *ngIf="isLoading$ | async">{{ translations['loading'] }}</span>
            <span *ngIf="isdeleting$ | async">{{ translations['deleting'] }}</span>
            <span *ngIf="isUpdating$ | async">{{ translations['updating'] }}</span>
          </ng-template>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>
